import React, { useContext } from 'react';
import { bool } from 'prop-types';
import classNames from 'classnames/bind';

import ResultsListInfo from 'components/ResultsListInfo';
import ResultsList from 'components/ResultsList';
import Loader from 'components/Loader';
import NoResults from 'components/NoResults';

import { SearchContext } from 'context/SearchContext';

import styles from './SearchResultsTab.module.scss';
const cx = classNames.bind(styles);

const SearchResultsTab = ({ loading, noResults, data }) => {
  const { partName, carName } = useContext(SearchContext);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className={cx('results-wrapper', 'white-bg')}>
      {!noResults ? (
        <div className={cx('results-container')}>
          <ResultsListInfo itemsNumber={data.length} />
          <ResultsList data={data} />
        </div>
      ) : (
        <div className={cx('results-container')}>
          <NoResults searchWord={partName + ', <br />' + carName} />
        </div>
      )}
    </div>
  );
};

SearchResultsTab.propTypes = {
  loading: bool.isRequired,
};

export default SearchResultsTab;



// WEBPACK FOOTER //
// ./src/components/SearchResultsTab/SearchResultsTab.js